import type { NotifyPort } from '@/features/messages/domain/notify'
import type { ChatPort, TopicView } from '../domain/chat'

const listTopics = async (port: ChatPort, notify: NotifyPort): Promise<TopicView[]> => {
	try {
		return await port.listTopics()
	} catch {
		notify.error('chat.topicsLoadFailed')
		return []
	}
}

export { listTopics }
